import styled from 'styled-components';

// CONSTANTS
import { WHITE, MISCHKA } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const ContentWrap = styled.div`
  .section {
    padding-top: 80px;
    padding-bottom: 80px;

    &:first-of-type {
      padding-top: 110px;
    }

    &:last-of-type {
      padding-bottom: 90px;
    }

    ${breakpoints.down('sm')} {
      padding-top: 40px;
      padding-bottom: 40px;

      &:first-of-type {
        padding-top: 40px;
      }

      &:last-of-type {
        padding-bottom: 40px;
      }
    }

    &__title {
      margin-bottom: 16px;

      ${breakpoints.down('sm')} {
        line-height: 3.8rem;
      }
    }
  }

  .hero {
    &__subtitle {
      max-width: 522px;
    }

    &__img {
      ${breakpoints.down('xs')} {
        max-width: 100%;
      }
    }

    .section__title {
      line-height: 5.4rem;
      margin-bottom: 16px;

      ${breakpoints.down('xs')} {
        line-height: 3.8rem;
      }
    }

    .MuiButton-root {
      min-width: 270px;
    }

    ${breakpoints.down('xs')} {
      text-align: center;
    }
  }

  .services {
    padding-top: 40px;
    padding-bottom: 70px;

    &__title {
      margin-bottom: 40px;
    }

    &__list {
      margin: 0;
      padding: 0;
      list-style: none;
      display: flex;
      justify-content: space-between;
      align-items: center;

      img {
        transition: 0.4s ease-out;
        filter: grayscale(1);
        opacity: 0.6;

        &:hover {
          filter: none;
          opacity: 1;
        }
      }

      ${breakpoints.down('sm')} {
        flex-wrap: wrap;

        li {
          text-align: center;
          width: 33%;
          margin-bottom: 15px;

          img {
            max-width: 100%;
          }
        }
      }

      ${breakpoints.down('xs')} {
        li {
          width: 50%;
          padding: 0 5px;
        }
      }
    }

    ${breakpoints.down('sm')} {
      padding-bottom: 40px;
    }
  }

  .steps {
    &__subtitle {
      margin-bottom: 56px;
    }

    .list {
      margin: 0;
      list-style: none;
      padding: 0;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      li {
        width: 33%;
        padding: 20px 24px;
        max-width: 338px;
        margin-right: auto;
        margin-left: auto;

        ${breakpoints.down('xs')} {
          width: 100%;
        }
      }

      &__icon {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: ${p => p.theme.palette.primary.main};
        color: ${p => p.theme.palette.primary.contrastText};
        height: 54px;
        width: 54px;
        border-radius: 50%;
        margin-right: auto;
        margin-left: auto;
        margin-bottom: 16px;
        font-weight: 600;
      }

      &__title {
        white-space: pre-line;
      }
    }
  }

  .channels {
    &__title,
    &__subtitle {
      margin-right: auto;
      margin-left: auto;
    }

    .list {
      &__item {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 220px;
        background-color: ${WHITE};
        padding: 15px;
        border-radius: 15px;
        border: 1px solid ${MISCHKA};

        img {
          max-width: 100%;
        }

        ${breakpoints.down('sm')} {
          height: 180px;
        }
      }
    }
  }

  .info {
    text-align: center;

    &__title,
    &__subtitle {
      margin-right: auto;
      margin-left: auto;
    }

    &__img {
      max-width: 100%;
    }
  }

  .faq {
    &__title {
      font-size: 3rem;
      line-height: 3.4rem;
      margin-bottom: 16px;
    }

    &__list {
      > div:not(:last-of-type) {
        margin-bottom: 20px;
      }
    }
  }
`;

export default ContentWrap;
